<template>
  <div>
    <!-- Botón para expandir búsqueda avanzada -->
    <div>
      <div>
        <div>
          <ContactAgent :infoAgente="agente"></ContactAgent>
          <p class="  "><b>{{ $t('contactAgent.requestVisit') }}</b></p>
          <b-form @submit.prevent="enviarSolicitud">
            <div class="pb-0 mb-0">
              <input required :class="clase == 1 ? 'input-transparent' : 'form-control '" :placeholder="$t('contactAgent.name')" type="text" v-model="row.Nombre" />
            </div>

            <div class="pb-0 mb-0">
              <input required :class="clase == 1 ? 'input-transparent' : 'form-control '" :placeholder="$t('contact.emailPlaceholder')" type="text" v-model="row.Correo" />
              <input required :class="clase == 1 ? 'input-transparent' : 'form-control '" :placeholder="$t('contact.phonePlaceholder')" type="text" v-model="row.Telefono" />
              <b-form-textarea required :placeholder="$t('contactAgent.message')" id="textarea" v-model="row.Mensaje" rows="3" max-rows="6"></b-form-textarea>
            </div>
            <div class="button-container pt-2 mt-2">
              <button type="submit" class="btn btn-primary btn-short-pill"><i class="mb-0 pb-0 fa fa-envelope"></i> {{ $t('contactAgent.send') }}</button>

              <a
                :href="`https://wa.me/${agente.Celular}?text=${encodeURIComponent($t('contact.whatsappGreeting') + ', ' + $t('contact.whatsappInquiry'))}`"
                target="_blank"
                class="btn btn-light-secondary-opacity btn-short-pill"
              >
                <i class="mb-0 pb-0 fa fa-whatsapp"></i> {{ $t('detail.whatsappLabel') }}
              </a>
              <a :href="`tel:+${agente.Celular}`" target="_blank" class="btn btn-light-secondary-opacity btn-short-pill"> <i class="mb-0 pb-0 fa fa-phone"></i> {{ $t('detail.phoneLabel') }} </a>
            </div>
            <!-- <div class="  pt-2 mt-2">
              <button type="submit" class=" btn btn-primary btn-short-pill "><i class="mb-0 pb-0 fa fa-envelope"></i> Contactar</button>
              <button type="submit" class=" btn btn-primary btn-short-pill "><i class="mb-0 pb-0 fa fa-phone"></i> LLamar</button>
              <button type="submit" class=" btn btn-primary btn-short-pill "><i class="mb-0 pb-0 fa fa-whatsapp"></i> WhatsApp</button>
            </div> -->
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactAgent from "../components/ContactAgent.vue";
import { resolveStoredPublicDomain } from "@/utils/publicDomainStorage";

export default {
  components: {
    ContactAgent,
  },
  props: ["class", "clase", "botonTransparent ", "agent", "propiedad"],
  data() {
    return {
      agente: {},
      isAdvancedSearch: false,
      row: { Nombre: "", Celular: "", Mensaje: "", Correo: "" },
      ruta: "",
    };
  },
  mounted() {
    this.$watch(
      "agent",
      function () {
        this.$forceUpdate();
        if (this.agent != undefined) {
          console.log("agenteif", this.agent);
          this.getData();
        }
      },
      { immediate: true } // Opcional, para ejecutar inmediatamente
    );
    // console.log("el agente -->", this.agent);
    // this.getData();
  },
  methods: {
    resolvePublicDomain() {
      return resolveStoredPublicDomain(this.$domain);
    },
    obtenerRutaActual() {
      this.ruta = `${window.location.origin}${this.$route.fullPath}`;
      console.log("Ruta actual:", this.ruta);
    },
    async getData() {
      try {
        const resolvedDomain = this.resolvePublicDomain();
        let res = await this.$store.dispatch("get", {
          path: `Agente/public/get/${this.agent}?domain=${encodeURIComponent(resolvedDomain)}`,
        });
        console.log("IdAgent -getData-ln-65 --->", res);
        this.agente = res;
      } catch (error) {
        this.agente = {};
        console.log("error in contactInfo", error);
        // alert(error);
      }
    },
    async enviarSolicitud() {
      try {
        this.obtenerRutaActual();
        console.log(this.agente);
        this.row.propiedad = this.propiedad;

        this.row.Mensaje = this.row.Mensaje + " <br> " + this.ruta;
        console.log("Agente/envioCorreo/" + this.agente.Email);
        let respuesta = await this.$store.dispatch("post", {
          path: "Agente/envioCorreo/" + this.agente.Email,
          data: this.row,
        });
        console.log(respuesta);
        this.$swal({
          icon: "success",
          title: this.$t("common.successTitle"),
          text: this.$t("contactAgent.successMessage"),
        });
        this.row.Mensaje = "";
        this.row.Nombre = "";
        this.row.Celular = "";
        this.row.Correo = "";
      } catch (error) {
        console.log("error", error);
      }
    },
  },
};
</script>

<style scoped>
/* Estilos básicos para el formulario */
.button-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.button-container > button,
a {
  flex: 1 1 auto; /* Ajusta automáticamente el tamaño */
  min-width: 150px; /* Evita que se hagan demasiado pequeños */
  max-width: 100%; /* Limita el tamaño máximo para evitar desbordamiento */
  margin: 0.25rem; /* Espaciado interno uniforme */
}

/* Para pantallas muy pequeñas, forzar a 100% */
@media (max-width: 480px) {
  .button-container > button,
  a {
    flex: 1 1 100%;
    max-width: none;
    margin: 0.5rem 0;
  }
}
label {
  display: block;
  margin-bottom: 0.5em;
}
input,
select {
  width: 100%;
  padding: 0.5em;
  margin-bottom: 1em;
}
button {
  margin-top: 1em;
}
</style>
